import { useQuery } from '@tanstack/react-query'
import { useCurrentUser } from '../currentUser'
import { fetchLucaUsage } from '../lucaUsage'

export const lucaUsageQueryKey = (slug: string) => [slug, 'luca-usage'] as const

export const lucaUsageQueryOptions = (slug: string) => ({
  queryKey: lucaUsageQueryKey(slug),
  queryFn: () => fetchLucaUsage({ slug })
})

export const useLucaUsage = (slug: string, enabled = true) => {
  const { data: user } = useCurrentUser()

  return useQuery({
    ...lucaUsageQueryOptions(slug),
    enabled: Boolean(user) && Boolean(slug) && enabled
  })
}
